import apiClient from './client'
import type { AuthResponse, User } from '../types'

export const authApi = {
  login: async (username: string, password: string): Promise<AuthResponse> => {
    const formData = new FormData()
    formData.append('username', username)
    formData.append('password', password)
    
    return apiClient.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },

  getMe: async (): Promise<User> => {
    return apiClient.get('/auth/me')
  },

  logout: async (): Promise<void> => {
    return apiClient.post('/auth/logout')
  },
}

export default authApi
